/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type AccountDeleteRpcRequest = { appId: number; accountId: number };

export type AppAccountDeleteRpcResponse = {
  appId: number;
  portalId: number;
  userId?: number;
  accountId: number;
  deletedAt: number;
  initiatingUserId?: number;
};

export type AppPermissionDataClassification =
  | 'NORMAL'
  | 'CONDITIONALLY_SENSITIVE'
  | 'SENSITIVE'
  | 'HIGHLY_SENSITIVE'
  | unhandledEnumCase;

export type AppUninstallRpcRequest = { appId: number };

export type AppUninstallRpcResponse = {
  portalId: number;
  userId?: number;
  appId: number;
  uninstalledAt: number;
  initiatingUserId?: number;
};

export type ApplicationInstallError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetInstalledAppsWithAppPermissionsForDataClassificationRequest = {
  dataClassification: AppPermissionDataClassification;
};

export type GetInstalledAppsWithAppPermissionsForDataClassificationResponse = {
  installedApps: Default<InstalledAppWithMatchingAppPermissions[]>;
};

export type GetUserInstallInfosRequest = { appId: number };

export type GetUserInstallInfosResponse = {
  infoForInstalledUsers: Default<UserInfoForInstall[]>;
};

export type InstalledAppWithMatchingAppPermissions = {
  appId: number;
  appName: string;
  matchingAppPermissionNames: Default<string[]>;
};

export type UninstallAppForUserRequest = {
  appId: number;
  userId: number;
  businessUnitId?: number;
};

export type UninstallAppForUserResponse = {};

export type UserInfoForInstall = {
  userId: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  installedAt: number;
  connectedStatus?: string;
  appId: Default<number>;
};

export type ErrorType =
  | 'INPUT_TOO_LONG'
  | 'INVALID_REQUEST'
  | 'WRONG_APP_LEVEL'
  | 'NOT_BUSINESS_UNIT_ENABLED'
  | 'PORTAL_FROM_WRONG_DATA_CENTER'
  | 'PORTAL_ID_REQUIRED'
  | 'USER_ID_REQUIRED'
  | 'BUSINESS_UNIT_ID_REQUIRED'
  | 'INVALID_PORTAL'
  | 'APPLICATION_NOT_FOUND'
  | 'UNINSTALL_SCOPE_REQUIRED'
  | 'APP_NOT_OWNED_BY_DEVELOPER_PORTAL'
  | 'ACCOUNT_ID_MISSING'
  | 'INTERNAL_ERROR'
  | unhandledEnumCase;

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type UninstallAppRequestType = Requestify<AppUninstallRpcRequest>;
export type UninstallAppResponseType = AppUninstallRpcResponse;
export type UninstallAppErrorType = ApplicationInstallError & HubspotMetadata;
export const uninstallAppRpc: ChirpAvroRpcDetails<
  UninstallAppRequestType,
  UninstallAppResponseType,
  UninstallAppErrorType,
  false
> = {
  serviceName: 'com.hubspot.application.installs.rpc.ApplicationInstallsRpc',
  rpcName: 'uninstallApp',
  auth: 'app',
  fingerprint: '_9ePcO86XWixeh47ZVTbHMoxpaDSD3KL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteAccountRequestType = Requestify<AccountDeleteRpcRequest>;
export type DeleteAccountResponseType = AppAccountDeleteRpcResponse;
export type DeleteAccountErrorType = ApplicationInstallError & HubspotMetadata;
export const deleteAccountRpc: ChirpAvroRpcDetails<
  DeleteAccountRequestType,
  DeleteAccountResponseType,
  DeleteAccountErrorType,
  false
> = {
  serviceName: 'com.hubspot.application.installs.rpc.ApplicationInstallsRpc',
  rpcName: 'deleteAccount',
  auth: 'app',
  fingerprint: 'lrs_LE4qSMBeP1PtSIXotMoxpaDSD3KL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetUserInstallInfosRequestType =
  Requestify<GetUserInstallInfosRequest>;
export type GetUserInstallInfosResponseType = GetUserInstallInfosResponse;
export type GetUserInstallInfosErrorType = ApplicationInstallError &
  HubspotMetadata;
export const getUserInstallInfosRpc: ChirpAvroRpcDetails<
  GetUserInstallInfosRequestType,
  GetUserInstallInfosResponseType,
  GetUserInstallInfosErrorType,
  false
> = {
  serviceName: 'com.hubspot.application.installs.rpc.ApplicationInstallsRpc',
  rpcName: 'getUserInstallInfos',
  auth: 'app',
  fingerprint: 'nE17L21F-AuNZhsimSq_gsoxpaDSD3KL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UninstallAppForUserRequestType =
  Requestify<UninstallAppForUserRequest>;
export type UninstallAppForUserResponseType = UninstallAppForUserResponse;
export type UninstallAppForUserErrorType = ApplicationInstallError &
  HubspotMetadata;
export const uninstallAppForUserRpc: ChirpAvroRpcDetails<
  UninstallAppForUserRequestType,
  UninstallAppForUserResponseType,
  UninstallAppForUserErrorType,
  false
> = {
  serviceName: 'com.hubspot.application.installs.rpc.ApplicationInstallsRpc',
  rpcName: 'uninstallAppForUser',
  auth: 'app',
  fingerprint: 'GUWsuNcLJfOWOt0ZIQbQa8oxpaDSD3KL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetInstalledAppsWithAppPermissionsForDataClassificationRequestType =
  Requestify<GetInstalledAppsWithAppPermissionsForDataClassificationRequest>;
export type GetInstalledAppsWithAppPermissionsForDataClassificationResponseType =
  GetInstalledAppsWithAppPermissionsForDataClassificationResponse;
export type GetInstalledAppsWithAppPermissionsForDataClassificationErrorType =
  ApplicationInstallError & HubspotMetadata;
export const getInstalledAppsWithAppPermissionsForDataClassificationRpc: ChirpAvroRpcDetails<
  GetInstalledAppsWithAppPermissionsForDataClassificationRequestType,
  GetInstalledAppsWithAppPermissionsForDataClassificationResponseType,
  GetInstalledAppsWithAppPermissionsForDataClassificationErrorType,
  false
> = {
  serviceName: 'com.hubspot.application.installs.rpc.ApplicationInstallsRpc',
  rpcName: 'getInstalledAppsWithAppPermissionsForDataClassification',
  auth: 'app',
  fingerprint: 'US8i6qI8Vx1BFcBMMgWySsoxpaDSD3KL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
